import React, { useState } from "react";
import { Alert, Form, Toast } from "react-bootstrap";

import translate from "../../../services/Translate";
import DstButton from "../../DstButton/DstButton";
import Popup from "../../Popup/Popup";
import { CreateCustomFilterPopupProps } from "./CreateCustomFilterPopup.d";

const MAX_NAME_LENGTH = 100;

const CreateCustomFilterPopup = ({
  closeModal,
  currentFilters,
  formId,
  language,
  show,
  storageKey,
}: CreateCustomFilterPopupProps) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [name, setName] = useState("");
  const [showToast, setShowToast] = useState(false);

  const _closeModal = () => {
    setErrorMessage("");
    setName("");
    closeModal();
  };

  const _createNewFilter = () => {
    const customFilterName = name.trim();
    if (!customFilterName) return;

    try {
      const existingFilters = JSON.parse(localStorage.getItem(storageKey) || "{}");

      if (Object.keys(existingFilters).some((key) => key.toLowerCase() === customFilterName.toLowerCase())) {
        setErrorMessage(translate(language, "COMPONENTS.CUSTOM_FILTERS.MODAL.ERRORS.NAME_EXISTS"));
        return;
      }

      localStorage.setItem(storageKey, JSON.stringify({ ...existingFilters, [customFilterName]: currentFilters }));
      setErrorMessage("");
      setName("");
      setShowToast(true);
      closeModal();
    } catch (error) {
      console.error("An error occurred with custom filters.", error);
    }
  };

  return (
    <React.Fragment>
      <Popup
        footerContent={
          <React.Fragment>
            <DstButton clickFunction={_closeModal} value={translate(language, "GLOBAL.CANCEL")} variant="secondary" />
            <DstButton
              clickFunction={_createNewFilter}
              disabled={!name.trim().length}
              value={translate(language, "GLOBAL.CREATE")}
            />
          </React.Fragment>
        }
        modalTitle={translate(language, "COMPONENTS.CUSTOM_FILTERS.MODAL.TITLE")}
        onClose={_closeModal}
        scrollable
        show={show}
      >
        <Form
          id={formId}
          onSubmit={(event) => {
            event.preventDefault();
            _createNewFilter();
          }}
        >
          <Form.Group controlId={`${formId}-name`}>
            <Form.Label>
              {translate(language, "COMPONENTS.CUSTOM_FILTERS.MODAL.LABELS.CREATE_CUSTOM_FILTER")}
            </Form.Label>
            <Form.Control
              className={`border-secondary ${!name.trim().length ? "text-muted" : ""} ${
                errorMessage ? "is-invalid" : ""
              }`}
              maxLength={MAX_NAME_LENGTH}
              onChange={(event) => setName(event.target.value)}
              placeholder={translate(language, "COMPONENTS.CUSTOM_FILTERS.MODAL.PLACEHOLDERS.NAME")}
              type="text"
              value={name}
            />
            <div className="text-end text-muted mt-1 xs-regular">
              {name.length}/{MAX_NAME_LENGTH}
            </div>
            {errorMessage && (
              <Alert className="mt-2 py-2" variant="danger">
                {errorMessage}
              </Alert>
            )}
          </Form.Group>
        </Form>
      </Popup>
      <Toast
        autohide
        bg="success"
        className="position-fixed top-0 end-0 m-3"
        delay={3000}
        onClose={() => setShowToast(false)}
        show={showToast}
      >
        <Toast.Body className="text-white">
          {translate(language, "COMPONENTS.CUSTOM_FILTERS.MODAL.SUCCESS.CREATE_CUSTOM_FILTER")}
        </Toast.Body>
      </Toast>
    </React.Fragment>
  );
};

export default CreateCustomFilterPopup;
